module.exports = __webpack_public_path__ + "img/benefit-1-job.8d18cd52.png";